import { render, staticRenderFns } from "./bianmin.vue?vue&type=template&id=1388e9fa&scoped=true"
import script from "./bianmin.vue?vue&type=script&lang=js"
export * from "./bianmin.vue?vue&type=script&lang=js"
import style0 from "./bianmin.vue?vue&type=style&index=0&id=1388e9fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1388e9fa",
  null
  
)

export default component.exports